import * as React from "react";
import { Box, Container, Grid, Paper } from "@mui/material";
import { marketingColors } from "../../../app/components/tickitMarketingTheme";
import { getBrandingColors } from "../brandingUtils";
import EventDetailsStrip from "../EventDetailsStrip";
import RegistrationBrandingHeader from "../RegistrationBrandingHeader";
import RegistrationFormCard from "../RegistrationFormCard";
import RegistrationPageFooter from "../RegistrationPageFooter";
import { cardSx, layout, pageBgSx } from "../templateLayout";

export default function SplitTemplate({ page, event, user, onSubmit, submitting }) {
  const branding = page?.branding || {};
  const { primary, accent } = getBrandingColors(branding);

  return (
    <Box sx={{ ...pageBgSx(), bgcolor: marketingColors.gray100 }}>
      <Container maxWidth="md" sx={{ px: layout.pagePx, py: layout.pagePy }}>
        <Grid container spacing={{ xs: 2, sm: 3 }}>
          <Grid item xs={12} md={5}>
            <Paper
              elevation={0}
              sx={{
                ...cardSx(branding),
                p: layout.cardPadding,
                height: "100%",
                background: `linear-gradient(160deg, ${primary} 0%, ${accent} 100%)`,
                color: "#fff",
                border: "none",
              }}
            >
              <RegistrationBrandingHeader
                branding={branding}
                event={event}
                variant="light"
                centered={false}
              />
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 2, sm: 2.5 },
                  mt: { xs: 2, sm: 3 },
                  borderRadius: 2,
                  bgcolor: "rgba(255,255,255,0.96)",
                }}
              >
                <EventDetailsStrip event={event} branding={branding} primaryColor={primary} dense />
              </Paper>
            </Paper>
          </Grid>
          <Grid item xs={12} md={7}>
            <RegistrationFormCard
              event={event}
              user={user}
              branding={branding}
              primaryColor={primary}
              onSubmit={onSubmit}
              submitting={submitting}
              showEventDetails={false}
              sx={{ height: "100%" }}
            />
          </Grid>
        </Grid>
        <RegistrationPageFooter branding={branding} />
      </Container>
    </Box>
  );
}
